export default "__VITE_ASSET__WD22hSz2__"